module.exports = {"230602001":"萨尔图街道","230602005":"铁人街道","230602006":"友谊街道","230602007":"富强街道","230602008":"拥军街道","230602009":"会战街道","230602010":"火炬街道","230602011":"东风街道","230602012":"东安街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230602.json
// module id = 674
// module chunks = 0